var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "source-view" },
    [
      _vm._l(_vm.renderList, function(thumb, index) {
        return _c(
          "section",
          {
            staticClass: "source-bg-img",
            on: {
              click: function($event) {
                return _vm.Preview22(thumb.src)
              }
            }
          },
          [
            _c(
              "div",
              { style: { "background-image": "url(" + thumb.ThumbUrl + ")" } },
              [
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "img-loaded-detect",
                  attrs: { src: thumb.ThumbUrl },
                  on: {
                    load: function($event) {
                      return _vm.$placeImg($event, "parent")
                    }
                  }
                })
              ]
            )
          ]
        )
      }),
      _vm._v(" "),
      _c("water-mark", { ref: "watermark" }),
      _vm._v(" "),
      _vm.callUnauthorize
        ? _c("unauthorize", { attrs: { unauthorizeType: _vm.unauthorizeType } })
        : _vm._e(),
      _vm._v(" "),
      _c("photo-package", {
        ref: "sourcePreview",
        attrs: {
          selector: ".source-bg-img",
          list: _vm.renderList,
          options: _vm.options
        },
        on: { "on-close": _vm.closeHandler }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-743446fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-743446fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/sourceView.vue
// module id = null
// module chunks = 